import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import * as actions from "../actions";
import UserList from "./userListContainer/userListContainer";
import UserListOld from "./userListContainer/userListContainerOld";
import SystemIdListContainer from "./systemIdListContainer";
import MerchantDetails from "../components/merchantDetails";
import BamboraSvgIcom from "../../common/bamboraSvgIcon";
import Spinner from "../../common/spinner";
import { doubleAuthEnabled } from "../../common/authHelper";

const doubleAuth = doubleAuthEnabled();

class MerchantDetailViewContainer extends Component {
  UNSAFE_componentWillMount() {
    let merchantId = this.props.match.params.merchantId;
    let apiHost = this.props.endpoints.apiHost;
    this.props.dispatch(actions.getMerchantDetails(apiHost, merchantId));
    this.props.dispatch(actions.getUsersForMerchant(apiHost, merchantId));
    this.props.dispatch(actions.getMerchantSource(apiHost, merchantId));
  }

  render() {
    return (
      <div>
        <div className="secondary-nav">
          <Link to="/" className="back-button">
            <BamboraSvgIcom icon="arrow-left" className="fill-inherit" />
            Back
          </Link>
        </div>

        {this.props.impersonation.merchantDetails ? (
          <div style={{ width: 1050, margin: "160px auto" }}>
            <MerchantDetails {...this.props} />
            <hr />
            <SystemIdListContainer {...this.props} />
            <hr />
            {doubleAuth ? <UserList {...this.props} /> : <UserListOld {...this.props} />}
          </div>
        ) : (
          <div style={{ width: "1100px", margin: "160px auto" }}>
            <div className="text-center">
              <Spinner waiting="true" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    impersonation: state.get("impersonation").toJS(),
    endpoints: state.getIn(["config", "endpoints"]),
  };
};

export default connect(mapStateToProps)(MerchantDetailViewContainer);
